import { isDynamicReport } from 'modules/campaigns/config/isStaticDynamicReport';
import {
    FEATURE_FLAGS,
    useAccountConfig,
    useConfigMatch,
} from 'modules/taboola-common-frontend-modules/account-configurations';
import { usePermissions } from 'modules/taboola-common-frontend-modules/authentication';

export const useReportExportAllowed = ({ reportConfig = {}, totalRows }) => {
    const { disableExport, id } = reportConfig;
    const isReportDynamic = isDynamicReport(id);
    const maxRowsFlag = isReportDynamic
        ? FEATURE_FLAGS.MAX_TOTAL_RECORDS_FOR_DYNAMIC_REPORT_EXPORT
        : FEATURE_FLAGS.MAX_TOTAL_RECORDS_FOR_REPORT_EXPORT;

    const { [maxRowsFlag]: maxAllowedRows } = useAccountConfig([maxRowsFlag]);
    const isUserPermitted = usePermissions('ADS_CONSOLE_EXPORT_REPORT_PERMITTED');

    const isAllowed = !disableExport && totalRows < maxAllowedRows;
    const isVisible = !!totalRows && isUserPermitted;
    const isAsync = useConfigMatch({
        [isReportDynamic ? FEATURE_FLAGS.DYNAMIC_REPORT_ASYNC_EXPORT : FEATURE_FLAGS.NEW_EXPORT]: 'true',
    });

    return { isVisible, isAllowed, maxAllowedRows, isAsync };
};
